<template>
  <div class="app-container">
    <BjDivider right-fixed
      >{{ $t('billingPage.BillingServiceInvoices') }}
      <template #right>
        {{ $t('billingPage.totalBalance') }} ：<a style="color: cadetblue">${{ extendData?extendData:0 }}</a>
        <el-button :disabled="!showBtn" type="primary" plain @click="onExportBill">{{ $t('billingPage.Download') }}</el-button>
      </template>
    </BjDivider>
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :label-width="'100px'"
      :search-btn-span="colSpan"
      :get-action="queryApi"
      :before-reset-search="beforeResetSearch"
      :tooltip-config="{ showAll: false, enterable: false }"
      @afterFetchOriginalData="getListData"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
      >
      <template v-slot:baseForm>
        <!-- 发票号 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.searchIDs')" prop="invoiceId">
            <BjInputNumber
              v-model="queryParams.invoiceId"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('billingPage.searchID')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <!-- 年-周 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.yearAndWeek')" prop="year">
            <el-date-picker
              id="getWeekDate"
              v-model="weekDataNow"
              :picker-options="{ firstDayOfWeek: 1 }"
              style="width: 100%"
              type="week"
              format="yyyy-WW"
              :clearable="false"
              :placeholder="$t('billingPage.yearAndWeeks')"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- 状态 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.Status')" prop="state">
            <BjSelectLov
              v-model="queryParams.state"
              :clearable="false"
              :option-list="BILLING_PAGE_STATUS"
            />
          </el-form-item>
        </el-col>

        <!-- css空壳 -->
        <el-col :span="colSpan">
          <div style="width: 30px; height: 10px"></div>
        </el-col>
      </template>

      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'invoiceNo'">
                <span style="color: #3173d0;">{{ scope.row[col.prop] }}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'state'">
                {{ $t(BILLING_PAGE_STATUS.bjGet(scope.row.state)) }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onInvoice(props.row)">{{ $t('billingPage.downloadInvoice') }}</el-button>
              <el-button type="text" class="edit-btn" @click="onReport(props.row)">{{ $t('billingPage.downloadReport') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { billApi } from '@/api';
import { BILLING_PAGE_STATUS } from '@/utils/constants';
import { getFileUrl } from '@/api/billApi';

export default {
  name: 'BusinessBillingServiceInvoices',
  components: {},
  mixins: [pageMiXin],

  data() {
    return {
      BILLING_PAGE_STATUS,
      colSpan: 6,
      pageData: [],
      extendData: null,
      // 查询参数
      queryApi: billApi.getBillServiceInvoiceList,
      queryParams: {
        invoiceId: null,
        year: null,
        state: null,
      },

      labelList: [
        { label: this.$t('billingPage.invoiceNumber'), prop: 'id', isCheck: true, disabled: false, width: 141 },
        { label: this.$t('billingPage.Year'), prop: 'year', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Week'), prop: 'week', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Date'), prop: 'dueDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.invoicePrice'), prop: 'totalAmount', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Paid'), prop: 'paidAmount', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Balance'), prop: 'balance', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Status'), prop: 'state', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 242 },
      ],
      weekDataNow: null,
      showBtn: true,
    };
  },
  watch: {
    'weekDataNow'() {
      if (this.weekDataNow !== null) {
        this.$nextTick(() => {
          this.queryParams.year = document.querySelector('#getWeekDate').value;
        });
      }
    },
  },
  methods: {
    // 获取页面右上角 应付款总金额
    getListData(data) {
      this.extendData = data.extendData;
      this.showBtn = data.content.length > 0;
    },
    // 下载Invoice Statement
    onExportBill() {
      getFileUrl('dowmBillInvoiceStatement');
      // billApi.dowmBillInvoiceStatement().then((resp) => {
      //   downloadBlob(resp, `Invoice Statement.pdf`);
      // });
    },
    // 下载Invoice
    onInvoice(item) {
      getFileUrl('dowmBillInvoice', {invoiceId: item.id});
      // billApi.dowmBillInvoice({invoiceId: item.id}).then((res) => {
      //   console.log(res);
      //   downloadBlob(res, `Invoice.pdf`);
      // });
    },
    // 下载Invoice Report
    onReport(item) {
      getFileUrl('dowmBillInvoiceReport', {invoiceId: item.id});
      // billApi.dowmBillInvoiceReport({invoiceId: item.id}).then((res) => {
      //   console.log(res);
      //   downloadBlob(res, `Invoice Report.csv`);
      // });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParams.year = null;
      this.weekDataNow = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
